<template>
  <div>
    <v-alert v-if="error" type="error">
      {{ error }}
    </v-alert>
    <template v-else>
      <v-progress-linear indeterminate v-if="loading"> </v-progress-linear>
      <div v-else-if="parties.length == 0">
        <v-alert icon="mdi-ticket" text color="info" class="mt-6">
          <div class="d-flex justify-space-between gap-3 align-center">
            <div>
              <span class="font-weight-bold text-18 lh-1">
                Nenhuma venda encontrada!
              </span>
              <p class="mb-0">
                Você podera acompanhar suas vendas assim que realizar a primeira
                aqui.
              </p>
            </div>
            <v-btn elevation="0">
              <span> Vender </span>
            </v-btn>
          </div>
        </v-alert>
      </div>
      <v-row v-else>
        <v-col cols="12" sm="6" lg="4" v-for="party in parties" :key="party.id">
          <my-sales-party-card :party="party" />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import ORGANIZATION from "@/services/admin/organization";
import { mapGetters } from "vuex";
import MySalesPartyCard from "../../components/admin/organization/mySales/MySalesPartyCard.vue";
export default {
  components: { MySalesPartyCard },
  metaInfo() {
    return { title: "Minhas vendas" };
  },
  data: () => ({
    loading: false,
    error: null,
    parties: [],
  }),
  methods: {
    async getMySales() {
      try {
        this.loading = true;
        const { parties } = await ORGANIZATION.mySales(
          this.selectedOrganization.id
        );
        this.parties = parties;
      } catch (err) {
        this.error = err.message || "Ocorreu um erro ao carregar suas vendas";
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization"]),
    ...mapGetters("auth", ["hasPermission"]),
  },
  watch: {
    "selectedOrganization.id"() {
      this.getMySales();
    },
  },
  mounted() {
    this.getMySales();
  },
};
</script>

<style></style>
